module.exports = __webpack_public_path__ + "static/img/Group 260.cc1b738c.png";